export default {
    LOAD_RECEIPT(state, receipt) {
        state.items = receipt
    }
}